import { HpAction, HpDispatchFunction } from '../types';

export type HpErrorPageDisplayedAction = HpAction<HpErrorPageDisplayedPayload>;

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface HpErrorPageDisplayedPayload {}

export function errorPageDisplayedAction(): (dispatch: HpDispatchFunction<HpErrorPageDisplayedPayload>) => void {
  return (dispatch: HpDispatchFunction<HpErrorPageDisplayedPayload>): void => {
    dispatch({ type: 'ERROR_PAGE_DISPLAYED' });
  };
}
